import Vue from 'vue'
import Vuex from 'vuex'
import app from './app'
import auth from './auth'
import code from './code'
import activity from './activity'
import cart from './cart'
import activityCate from './activityCate'
import payApply from './pay-apply'
import payResult from './pay-result'
import products from './products'
import order from './order'
import express from './express'
import activityLimit from './activityLimit'
import * as modules from './modules'

Vue.use(Vuex)

export default new Vuex.Store({

  modules: {
    app,
    auth,
    code,
    activity,
    cart,
    activityCate,
    payApply,
    payResult,
    products,
    order,
    express,
    activityLimit,
    ...modules
  }

})
